import { getPermissionSettings } from 'common/utils/permissions/helpers';

export const isAuthorized = () => {
  return true;
};

export const getAuthorizedPermissionSettings = (
  account,
  permission,
  mode = 'or',
  environments = []
) => {
  return getPermissionSettings({ account, permission, mode, environments }, false);
};
